//Core
import React from "react"

//Styles
import style from "./style.module.scss"

//Images
import Plus from "../../../../images/plus.png"
import Minus from "../../../../images/minus.png"

const AccordionItem = ({ title, text, show, click, index }) => {
  return (
    <div
      className={[style.title, show ? style.active : ""].join(" ")}
      onClick={() => click(index)}
    >
      <div className={style.wrapper}>
        <img className={style.icon} src={show ? Minus : Plus} alt="PLus" />
        <div>
          <span className={style.subTitle}>{title}</span>

          {show ? <div className={style.text}>{text}</div> : null}
        </div>
      </div>
    </div>
  )
}

export default AccordionItem
